import styled from 'styled-components'

export const SearchListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > .pack-list-item {
    margin: 24px 12px 0 12px;
  }
`
